module.exports = __webpack_public_path__ + "assets/img/illust_03_large.ecf5c531.png";